<template>
  <div>
    <div class="page-title-banner">
      <div v-if="showBack" v-active-touch class="left-menu" @click="backTo">
        <MapIcon v-if="backIcon === 'map'" />
        <BackIcon v-else />
      </div>
      <img v-if="showBrandIcon" :src="brand_favicon" alt="icon">
      <span class="page-title">{{title}}</span>
    </div>
    <div class="placeholder"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BackIcon from '@/components/icons/BackIcon.vue';
import MapIcon from '@/components/icons/MapIcon.vue';

export default {
  name: "PageTitleBanner",
  components: {
    BackIcon,
    MapIcon
  },
  props: {
    title: String,
    showBack: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    back: {
      type: [String, Object],
      default: ''
    },
    backIcon: {
      type: String,
      default: 'back'
    }
  },
  computed: {
        ...mapGetters('appConfig', ['brand_favicon']),
        showBrandIcon() {
          return !!this.showIcon && !!this.brand_favicon;
        }
  },
  methods: {
    backTo() {
      if (this.back) {
        if (typeof this.back === 'string') {
          this.$router.push({ path: this.back });
          return;
        }
        this.$router.push(this.back);
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss">
.page-title-banner {
  width: 100%;
  margin: 0 auto 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background: #fff;
  z-index: 999;
  .left-menu {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &.touch-active {
      transform: translateY(-50%) scale(0.94);
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }
  img {
    height: 17px;
    width: 17px;
    object-fit: contain;
    margin-right: 10px;
  }
  .page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    letter-spacing: -0.4px;
  }
}
.placeholder {
  position: relative;
  height: 44px;
  opacity: 0;
  z-index: 0;
}
</style>
